<template>
  <div class=" tabs-container breadcrumb-tooltip tab-tooltip" :class="styleType" :style="settingsDefaultScrollBar()">
    <ul :class="styleType">
      <li
        v-for="(tab, index) in data"
        :key="index"
        @click="changeTab(tab)"
        :class="{ current: tab.name == tabCurrent, disabled: loading }"
      >
        <div v-if="tab.icon && !tab.position">
          <i :class="tab.icon"></i>
        </div>
        <div>
          {{ tab.title }}
          <span v-if="tab.tooltip" :class="{ tooltip: tab.tooltip }">
            <span v-if="tab.tooltip" class="tooltiptext">
              {{ tab.tooltip }}
              <br />
              <a v-if="tab.video" :href="tab.video" target="_blank" class="button small secondary">
                Saiba Mais
              </a>
            </span>
          </span>
          <span v-if="!tab.tooltip && tab.icon && tab.position === 'side' ">
            <i :class="tab.icon">
            </i>
          </span>

        </div>
      </li>

    </ul>
  </div>
</template>

<script>
export default {
  name: "tabs",
  props: {
    data: {
      default: [],
      required: true
    },
    value: {
      required: true,
      type: String
    },
    type: {
      default: "default",
      type: String
    },
    router: {
      default: null,
      type: Function
    },
    loading: {
      default: false,
      type: Boolean
    },
    disable: {
      default: false,
      type: Boolean
    },
    disableMsg: {
      type: String
    }
  },
  data() {
    return {
      tabCurrent: false
    };
  },
  methods: {
    settingsDefaultScrollBar(){
      if(this.type && this.type === "default-scroll"){
        return 'overflow:hidden; width: 70%;'
      }
    },
    changeTab(tab){
      if(this.loading) return;
      if(this.disable) {
        if(this.disableMsg) {
          this.$toast.error({
            title:'Erro',
            message: this.disableMsg
          })
        }
        return;

      }

      if(this.router){
        this.router(tab.name);
      }
      else {
        this.tabCurrent = tab.name;
      }
      
    }
  },
  mounted() {
    this.tabCurrent = this.value;
  },
  watch: {
    value() {
      this.tabCurrent = this.value;
    },
    tabCurrent() {
      if (this.tabCurrent !== this.value) {
        this.$emit("input", this.tabCurrent);
      }
    }
  },
  computed: {
    styleType() {
      if (["default","default-scroll", "simple", "box", "pages"].includes(this.type)) return this.type;
      return "default";
    }
  }
};
</script>

<style lang="scss" scoped>
hr {
  border: none;
  border-bottom: 2px solid var(--border);
  margin-bottom: 1px;
}
ul li {
  cursor: pointer;
}
.box ul.default {
  border-bottom: 1px solid var(--border);
}

ul.default-scroll {
  margin-bottom: 10px;
  font-size: 1.5rem;
  min-width: 100%;
  white-space: nowrap;
  // overflow-x: auto;
  li {
    display: inline-block;
    border-radius: 0px;
    font-weight: 400;
    margin-bottom: -1px;
    color: var(--text3);
    &.current {
      background: rgba(var(--primary), 0.07);
      color: var(--primary);
      font-weight: 600;
      // border-bottom: 2px solid var(--primary);
    }
    + li {
      margin-left: 15px;
    }

    &.disabled {
      opacity: 0.3;
      cursor:not-allowed;
    }
  }
  &:hover{
    overflow-x:auto;
    overflow-y: hidden;
  }
  &:last-child {
    margin-right: 15px;
  }
}

ul.default {
  margin-bottom: 10px;
  font-size: 1.5rem;
  li {
    padding: 5px 20px 10px;
    display: inline-block;
    border-radius: 0px;
    font-weight: 400;
    margin-bottom: -1px;
    color: var(--text3);
    &.current {
      background: rgba(var(--primary), 0.07);
      color: var(--primary);
      font-weight: 600;
      border-bottom: 2px solid var(--primary);
    }
    + li {
      margin-left: 5px;
    }

    &.disabled {
      opacity: 0.3;
      cursor:not-allowed;
    }
  }
}


ul.box {
  margin-bottom: 15px;
  font-size: 1.4rem;
  font-weight: 600;
  display: flex;
  li {
    min-width: 180px;
    background: rgba(#999, 0.1);
    border: 1px solid rgba(#999, 0.2);
    padding: 17px 25px 19px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    i {
      font-size: 15px;
      margin-right: 8px;
    }
    + li {
      margin-left: 15px;
    }

    &.current {
      background: rgba(var(--primaryRgb), 0.1);
      border-color: var(--primary);
    }
    &.disabled {
      opacity: 0.3;
      cursor:not-allowed;
    }
  }
}

ul.simple {
  display: flex;
  flex-direction: row;
  list-style: none;

  li {
    padding: 15px 25px;
    color: var(--text2);
    font-size: 1.5rem;
    cursor: pointer;
    border-radius: 6px 6px 0px 0px;
    background: var(--bg);
    opacity: 0.6;

    &.current {
      color: var(--text);
      background: var(--border0);
      opacity: 1;

      .light & {
        background: white;
        border: 1px solid var(--border);
        border-bottom: 0;
        margin-bottom: -1px;
        position: relative;
        z-index: 5;
      }
    }

    + li {
      margin-left: 10px;
    }
  }
}

ul.pages {
  margin-bottom: 22px;
  font-size: 1.5rem;
  border-bottom: 2px solid var(--border);
  display:flex;
  list-style-type:none;
  max-width:100%;


  li {
    flex: 1;
    border-top: 2px solid var(--border);
    border-right: 2px solid var(--border);
    border-radius: 0px;
    padding: 5px 20px 18px;
    text-align: center;
    color: var(--text3);
    max-width: 120px;
    background: rgba(var(--primary), 0.07);

    &:first-of-type {
      border-left: 2px solid var(--border);
    }

    &.current {
    background: var(--bgBox);
      color: var(--text);
      font-weight: 600;
      border-top: 2px solid var(--primary);
      box-shadow: 0px 4px 2px -1px var(--bgBox);
    }
    i {
      width: 50%;
      margin: 0 auto;
      color: var(--primary);
      margin: 16px;
    }
  }
}

.dark ul.simple {
  li {
    &.current {
      color: var(--text);
      background: rgba(white, 0.05);
    }
  }
}

ul::-webkit-scrollbar {
  width: 10px !important;
  height: 25px !important;
}
ul::-webkit-scrollbar-thumb {
    background-color: #8c36fc;
    border-radius: 20px;
    border: 10px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
}

@media screen and (max-width: 900px) {
  ul.simple li {
    font-size: 1.3rem;
    padding: 10px 2px;
  }
  .button.square {
    margin-bottom: 10px;
  }

  ul.default {
    width: 100%;
  }
  ul > li {
    margin-top: 6px;
  }
}
</style>
